import React from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import {Element} from "react-scroll"
import {useTranslation, Trans} from "react-i18next";

function Advantages() {
    const {t} = useTranslation();

    return  (
        <Element name="advantages">
            <Container className="my-5">
                <Card className="shadow-lg border-0 rounded-5 p-4">
                    <CardBody>
                        <h2 className="text-center text-success mb-5">
                            {t("advantagesTitle")}
                        </h2>
                        <Row>
                            <Col md="6" className="mb-4">
                                <Card className="shadow-sm border-0 rounded-4 h-100">
                                    <CardBody>
                                        <CardTitle tag="h4" className="mb-3">
                                            {t("qualityAndPurpose")}
                                        </CardTitle>
                                        <CardText>
                                            <Trans i18nKey="qualityAndPurposeBody1" components={{strong : <strong/>}}></Trans>
                                        </CardText>
                                        <CardText>
                                            <Trans i18nKey="qualityAndPurposeBody2" components={{strong : <strong/>, ul: <ul/>, li: <li/>}}></Trans>
                                        </CardText>
                                        <CardText>
                                            <Trans i18nKey="qualityAndPurposeBody3" components={{strong : <strong/>}}></Trans>
                                        </CardText>
                                        <CardText className="fw-bold">
                                            {t("qualityAndPurposeBody4")}
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col md="6" className="mb-4">
                                <Card className="shadow-sm border-0 rounded-4 h-100">
                                    <CardBody>
                                        <CardTitle tag="h4" className="mb-3">
                                            {t("environmentalProtectionTitle")}
                                        </CardTitle>
                                        <CardText>
                                            <Trans i18nKey="environmentalProtectionBody1" components={{strong : <strong/>}}></Trans>
                                        </CardText>
                                        <CardText>
                                            <Trans i18nKey="environmentalProtectionBody2" components={{strong : <strong/>, ul: <ul/>, li: <li/>}}></Trans>
                                        </CardText>
                                        <CardText>
                                            {t("environmentalProtectionBody3")}
                                        </CardText>
                                        <CardText>
                                            {t("environmentalProtectionBody4")}
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </Element>
    );
}

export default Advantages;
